import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  id: {
    model_name: 'Walk::Challenge',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Walk::Challenge',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Walk::Challenge',
    column_type: 'datetime',
  },
  amount_currency: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  sub_title: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  title: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  amount_cents: {
    model_name: 'Walk::Challenge',
    column_type: 'integer',
  },
  target: {
    model_name: 'Walk::Challenge',
    column_type: 'integer',
  },
  walk_club: {
    model_name: 'Walk::Challenge',
    column_type: 'belongs_to',
    extra: {
      association_name: 'walk_club',
      model_name: 'Walk::Club',
      foreign_key: 'walk_club_id',
    },
  },
  walk_club_id: {
    model_name: 'Walk::Challenge',
    column_type: 'belongs_to',
    extra: {
      association_name: 'walk_club',
      model_name: 'Walk::Club',
      foreign_key: 'walk_club_id',
    },
  },
  walk_prize: {
    model_name: 'Walk::Challenge',
    column_type: 'belongs_to',
    extra: {
      association_name: 'walk_prize',
      model_name: 'Walk::Prize',
      foreign_key: 'walk_prize_id',
    },
  },
  walk_prize_id: {
    model_name: 'Walk::Challenge',
    column_type: 'belongs_to',
    extra: {
      association_name: 'walk_prize',
      model_name: 'Walk::Prize',
      foreign_key: 'walk_prize_id',
    },
  },
  winners_count: {
    model_name: 'Walk::Challenge',
    column_type: 'integer',
  },
  end_date: {
    model_name: 'Walk::Challenge',
    column_type: 'date',
  },
  start_date: {
    model_name: 'Walk::Challenge',
    column_type: 'date',
  },
  prize_desc: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  is_started: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  is_ended: {
    model_name: 'Walk::Challenge',
    column_type: 'string',
  },
  introduction: {
    model_name: 'Walk::Challenge',
    column_type: 'text',
  },
  cover: {
    model_name: 'Walk::Challenge',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  cover_with_audio: {
    model_name: 'Walk::Challenge',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  detail_image: {
    model_name: 'Walk::Challenge',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  detail_image_with_audio: {
    model_name: 'Walk::Challenge',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
